import { Box, Grid, Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Filters } from "./components/filters";
import { TextButton } from "components/TextButton";
import { useStyles } from "./styles";
import { OlMap } from "components/OlMap";
import { useMapTab } from "./hooks";
import { RelatedOrders } from "./components/relatedOrders/relatedOrders";

type Props = {
  hasOrders: boolean
}

export const MapTab: FC<Props> = ({ hasOrders }) => {
  const classes = useStyles({});
  const { t } = useTranslation();
  const theme = useTheme();

  const {
    olMapRef,
    mapProperties,
    handleSelectAddress,
    handleSelectLocation,
    handleClearFilters,
    handleSearchProperty,
    propertySearchQuery,
    relatedOrders,
    locations,
    selectedLocations,
    locationDataState,
    zctaQuery,
    handleSearchZcta
  } = useMapTab();
  const hasSingleAddress = relatedOrders.length === 1;

  return (
    <Grid item container className={classes.mapTabContainer}>
      <Box className={classes.mapViewContainer}>
        <Box className={classes.mapContainer}>
          <OlMap
            ref={olMapRef}
            features={
              mapProperties.map(({ _id, address, geo }) => ({
                id: _id,
                type: 'Feature',
                geometry: { ...geo },
                properties: { label: address }
              }))
            }
            onFeatureSelect={handleSelectAddress}
            focusZoom={18}
          />
        </Box>
        <Paper className={classes.controls} elevation={1}>
          <Typography className={classes.title}>{t('common:orderMapExplorerTitle')}</Typography>

          <Box className={hasSingleAddress ? classes.hideFiltersOnMobile : classes.subTitleContainer}>
            <Typography className={classes.subTitle}>{t('common:propertyFilterTitle')}</Typography>
            <TextButton text={t('common:clear-all')} textColor={theme.palette.secondary.main} onClick={handleClearFilters} />
          </Box>

          <Box className={hasSingleAddress ? classes.hideFiltersOnMobile : undefined}>
            <Filters
              locationDataState={locationDataState}
              locations={locations}
              selectedLocations={selectedLocations}
              onSelectLocation={handleSelectLocation}
              zctaQuery={zctaQuery}
              onSearchZcta={handleSearchZcta}
            />

          </Box>
          <RelatedOrders
            relatedOrders={relatedOrders}
            onSearch={handleSearchProperty}
            propertySearchQuery={propertySearchQuery}
            hasOrders={hasOrders}
            hideSearchOnMobile={hasSingleAddress}
            showMobileClear={hasSingleAddress}
            onClear={handleClearFilters}
          />
        </Paper>
      </Box>

    </Grid>
  );
};